module.exports = __webpack_public_path__ + "img/gpic5.png";